import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="M185-507q-32 0-56-23-23-24-23-56v-197q0-33 23-57 24-23 56-23h590q33 0 56 23 24 24 24 57v197q0 32-24 56-23 23-56 23H185Zm0-79h590v-197H185v197Zm0 489q-32 0-56-24-23-23-23-56v-197q0-32 23-56 24-23 56-23h590q33 0 56 23 24 24 24 56v197q0 33-24 56-23 24-56 24H185Zm0-80h590v-197H185v197Zm0-606v197-197Zm0 409v197-197Z"/>',
  f: '<path d="M185-507q-32 0-56-23-23-24-23-56v-197q0-33 23-57 24-23 56-23h590q33 0 56 23 24 24 24 57v197q0 32-24 56-23 23-56 23H185Zm0 410q-32 0-56-24-23-23-23-56v-197q0-32 23-56 24-23 56-23h590q33 0 56 23 24 24 24 56v197q0 33-24 56-23 24-56 24H185Z"/>',
};

export default data;
